import { Button, Col, Modal } from 'components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { SignUp } from './components';

const Wrapper = styled.div`
  width: 100%;
  background-color: #e5e5e5;
  background-image: url(${require('assets/images/icon-ghost-grey.png')});
  background-repeat: no-repeat;
  background-position: ${(props) => (props.isMobile ? '0px 155px' : '0px 111px')};
  background-size: 70%;
  background-origin: border-box;
  overflow: hidden;

  @media (max-width: 1024px) {
    height: ${(props) => (props.isMobileViewLarger ? '100%' : '661px')};
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  background-color: rgba(229, 229, 229, 0.7);
`;

const SignUpModal = (props) => {
  const [visible, setVisible] = useState(false),
    [data, setData] = useState(null),
    navigate = useNavigate(),
    { innerHeight } = window,
    isMobileViewLarger = innerHeight - innerHeight / 20 > 661,
    { isMobile } = global,
    { t } = useTranslation();

  function handleModal() {
    setVisible(!visible);
  }

  return (
    <React.Fragment>
      <Button
        text={t('website.signUp')}
        website
        sportsSelect
        marg="0 20px 0 0"
        onClick={() => navigate('/signup')}
      />

      <Modal visible={visible} closeModal={handleModal} website>
        <Wrapper isMobileViewLarger={isMobileViewLarger}>
          <InnerWrapper>
            <Col pad={isMobile ? '55px 0' : '91px 0'} center>
              {!data && <SignUp setData={setData} />}

              {/*data && <Verification data={data}/>*/}
            </Col>
          </InnerWrapper>
        </Wrapper>
      </Modal>
    </React.Fragment>
  );
};

export default SignUpModal;
